import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { convertToOldJapaneseNumbers } from "../utils/numberUtils";

const WATANAGASHI_PHASE = "1-watanagashi";

const PhaseLabel = ({ order, title, phase, theme }) => {
  const isWatanagashiPhase =
    phase === WATANAGASHI_PHASE || (Number(order) === 1 && title === "綿流し祭");

  if (isWatanagashiPhase) {
    return (
      <>
        <span style={{ color: theme.system.colors.red }}>特</span>別章
      </>
    );
  }

  const oldNumber = convertToOldJapaneseNumbers(order);

  return (
    <>
      其の<span style={{ color: theme.system.colors.red }}>{oldNumber}</span>
    </>
  );
};

const PhaseTitle = ({ order, title, phase, sx }) => {
  const theme = useTheme();

  return (
    <Box sx={{ textAlign: "center", ...sx }}>
      <Typography
        sx={(theme) => ({
          fontFamily: theme.system.fonts.brush,
          fontSize: "13px",
        })}
      >
        <PhaseLabel order={order} title={title} phase={phase} theme={theme} />
      </Typography>
      <Typography
        sx={(theme) => ({
          fontFamily: theme.system.fonts.brush,
          fontSize: "24px",
          marginTop: -1,
        })}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default PhaseTitle;
